import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41b67927"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BFormInput = _resolveComponent("BFormInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BFormInput, {
      ref: "field1",
      maxlength: "1",
      value: _ctx.authCodes.code1,
      type: "number",
      autocomplete: "one-time-code",
      pattern: "\\d*",
      class: "code-input",
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput($event, 1))),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.onKeyupBackspace($event, 1)), ["backspace"]))
    }, null, 8, ["value"]),
    _createTextVNode(),
    _createVNode(_component_BFormInput, {
      ref: "field2",
      maxlength: "1",
      value: _ctx.authCodes.code2,
      type: "number",
      autocomplete: "one-time-code",
      pattern: "\\d*",
      class: "code-input",
      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInput($event, 2))),
      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.onKeyupBackspace($event, 2)), ["backspace"]))
    }, null, 8, ["value"]),
    _createTextVNode(),
    _createVNode(_component_BFormInput, {
      ref: "field3",
      maxlength: "1",
      value: _ctx.authCodes.code3,
      type: "number",
      autocomplete: "one-time-code",
      pattern: "\\d*",
      class: "code-input",
      onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onInput($event, 3))),
      onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.onKeyupBackspace($event, 3)), ["backspace"]))
    }, null, 8, ["value"]),
    _createTextVNode(),
    _createVNode(_component_BFormInput, {
      ref: "field4",
      maxlength: "1",
      value: _ctx.authCodes.code4,
      type: "number",
      autocomplete: "one-time-code",
      pattern: "\\d*",
      class: "code-input",
      onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInput($event, 4))),
      onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.onKeyupBackspace($event, 4)), ["backspace"]))
    }, null, 8, ["value"])
  ]))
}